import PropTypes from 'prop-types';
import { Icon } from '@evertrue/et-components';
import { createOutreachPlansColumns } from './outreach-plans-columns';
import CadenceFlexTable from './cadence-flex-table';

const TOGGLEABLE = [
  'type',
  'status',
  'cadenceShell',
  'createdBy',
  'createdDate',
  'lastUpdated',
  'totalContacts',
  'goalMetric',
  'automation',
  'avgDeliveryRate',
  'avgBounceRate',
  'avgUnsubscribeRate',
  'avgOpenRate',
  'avgClickRate',
  'avgReplyRate',
  'tags',
];

const HIDDEN_COLUMNS = {
  cadenceShell: false,
  createdDate: false,
  lastUpdated: false,
  totalContacts: false,
  automation: false,
  avgDeliveryRate: false,
  avgBounceRate: false,
  avgUnsubscribeRate: false,
  avgOpenRate: false,
  avgClickRate: false,
  avgReplyRate: false,
  tags: false,
};

const OutreachPlansTable = ({ data, loading, currentUserId, actions, renamingState, onSelectionChange }) => (
  <CadenceFlexTable
    tableKey="cadences-v2-outreach-plans"
    columns={createOutreachPlansColumns({ currentUserId, actions, renamingState })}
    data={data}
    loading={loading}
    onSelectionChange={onSelectionChange}
    toggleableColumns={TOGGLEABLE}
    columnVisibilityModel={HIDDEN_COLUMNS}
    emptyStateMessage="No Cadences or Plans found"
    emptyStateIcon={<Icon icon="cadences" iconKit="gt2" size={5} />}
  />
);

OutreachPlansTable.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  actions: PropTypes.object,
  renamingState: PropTypes.object,
  onSelectionChange: PropTypes.func,
};

export default OutreachPlansTable;
